import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";

/** Displays role names as readable labels. */
const Roles = ({ roles }) => {
  const rolesName = _.map(roles, (role) => _.startCase(_.toLower(role.name)));
  return <>{rolesName.join(", ")}</>;
};
Roles.propTypes = {
  roles: PropTypes.array,
};

export default Roles;
